import { Component, Input } from '@angular/core';
import { isNumber } from '@datorama/akita';
import { ConstrainedField } from '@shared/models/constrained-field';

@Component({
  selector: 'app-checkbox-group-cell',
  templateUrl: './checkbox-group-cell.component.html',
  styleUrls: ['./checkbox-group-cell.component.scss']
})
export class CheckboxGroupCellComponent {
  Object = Object;
  @Input() public field!: ConstrainedField;
  @Input() public checkboxTexts!: Record<string | number, string>;

  toDbModel(rawValue: Record<string | number, boolean>) {
    const readValue = [];

    Object.keys(rawValue).forEach(k => {
      if (rawValue[k] == true) {
        readValue.push(isNumber(k) ? parseInt(k) : k);
      }
    })

    return readValue.join(',');
  }
}
